import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminRolesPage } from "@/features/admin-roles/components/AdminRolesPage";
import { permisosCatalogoQueryOptions, rolesAdminQueryOptions } from "@/features/admin-roles/hooks/use-roles-admin";

/** Ruta `/admin/roles` · CRUD de roles (sistema protegidos + personalizados) + permisos. */
export const Route = createFileRoute("/_authed-tw/admin/roles")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminRoles])
      ? Promise.all([
      queryClient.ensureQueryData(rolesAdminQueryOptions),
      queryClient.ensureQueryData(permisosCatalogoQueryOptions),
    ])
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminRoles]}>
      <AdminRolesPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
